// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1vz71","Success":"Button_Success__3H3DF","Danger":"Button_Danger__2tkUk"};